<template>
  <div
      :class="[
      'flex items-start gap-3 w-full max-w-sm rounded-lg border p-4 shadow-lg',
      TOAST_VARIANTS[type].base
    ]"
      role="alert"
  >
    <component
        :is="icon"
        :class="['h-6 w-6 mt-0.5 flex-shrink-0', TOAST_VARIANTS[type].icon]"
    />

    <div class="flex-1 min-w-0">
      <p :class="['text-sm font-medium', TOAST_VARIANTS[type].title]">
        {{ title }}
      </p>
      <p
          v-if="message"
          :class="['mt-1 text-sm', TOAST_VARIANTS[type].message]"
      >
        {{ message }}
      </p>
    </div>

    <button
        @click="$emit('remove', id)"
        :class="[
        'flex-shrink-0 hover:opacity-70 transition-opacity',
        TOAST_VARIANTS[type].title
      ]"
        aria-label="Close notification"
    >
      <XIcon class="h-5 w-5" />
      <span class="sr-only">Close</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { XIcon } from 'lucide-vue-next';
import { CheckCircleIcon, XCircleIcon, AlertTriangleIcon, InfoIcon } from 'lucide-vue-next';
import {type Toast, TOAST_VARIANTS} from "@/types/components/toast";

const props = defineProps<Toast>();

defineEmits<{
  (e: 'remove', id: string): void;
}>();

const icon = computed(() => {
  const icons = {
    success: CheckCircleIcon,
    error: XCircleIcon,
    warning: AlertTriangleIcon,
    info: InfoIcon
  };
  return icons[props.type];
});
</script>